import { buildEndpoint, getBaseUrl } from '@utils/endpoint';

// `window.siteVars` comes from a separate host-page script. Falling back to the
// current origin keeps every endpoint a parseable URL instead of the literal
// string 'undefined/…' when that script has not run yet.
const WRITING_TOOLS_API_HOST = getBaseUrl(
  window.siteVars?.REACT_APP_WRITING_TOOLS_API_HOST
);
export const PARENT_DOMAIN_LINK = window.siteVars?.REACT_APP_PARENT_DOMAIN_LINK;

export const ENDPOINT = {
  GRAPHQL_EDUSSON_AI_TOOL: buildEndpoint(
    getBaseUrl(PARENT_DOMAIN_LINK),
    '/graphql/ai_tool'
  ),
  /**
   * Same endpoint behind the locale prefix (`/fr/graphql/ai_tool`), for queries
   * whose response the backend translates. A getter, not a constant: the locale
   * is published by a host-page script that may run after this module.
   */
  get GRAPHQL_EDUSSON_AI_TOOL_LOCALIZED(): string {
    return buildEndpoint(getBaseUrl(PARENT_DOMAIN_LINK), '/graphql/ai_tool', {
      withLocale: true,
    });
  },
  GRAPHQL_EDUSSON_FORM: buildEndpoint(
    getBaseUrl(PARENT_DOMAIN_LINK),
    '/graphql/front'
  ),

  PROMO_CODE: buildEndpoint(
    getBaseUrl(PARENT_DOMAIN_LINK),
    '/widget/subscription-promo-code'
  ),

  RESCUE_DISCOUNT: buildEndpoint(
    getBaseUrl(PARENT_DOMAIN_LINK),
    '/widget/subscription-rescue-popup-50-percent'
  ),

  GRAPHQL_WRITING_TOOLS_AI_CALL: `${WRITING_TOOLS_API_HOST}/graphql/ai_call`,

  LISTEN_GEN_TEXT: `${WRITING_TOOLS_API_HOST}/start-listen-gen-text-t2`,
  DETECT_AI_TEXT: `${WRITING_TOOLS_API_HOST}/ai_request_ai_detector_ko1`,

  GENERATE_FIRST_TEXT: `${WRITING_TOOLS_API_HOST}/ai_request_generate_text_first_ko1`,
  GENERATE_FIRST_TEXT_RESULT: `${WRITING_TOOLS_API_HOST}/ai_get_result_gen_first_ko1`,

  GENERATE_NEXT_TEXT: `${WRITING_TOOLS_API_HOST}/ai_request_generate_text_next_ko1`,
  GENERATE_NEXT_TEXT_RESULT: `${WRITING_TOOLS_API_HOST}/ai_get_result_gen_next_ko1`,

  HUMANIZE_FIRST_TEXT: `${WRITING_TOOLS_API_HOST}/ai_request_humanize_first_ko1`,
  HUMANIZE_FIRST_TEXT_RESULT: `${WRITING_TOOLS_API_HOST}/ai_get_result_humanize_first_ko1`,

  HUMANIZE_FIRST_TEXT_V2: `${WRITING_TOOLS_API_HOST}/ai_request_humanize_first_ko1/v2`,
  HUMANIZE_FIRST_TEXT_V2_RESULT: `${WRITING_TOOLS_API_HOST}/ai_get_result_humanize_first_ko1/v2`,

  PLAGIARISM_CHECK: `${WRITING_TOOLS_API_HOST}/ai_request_plag_check_ko1`,
  PLAGIARISM_CHECK_RESULT: `${WRITING_TOOLS_API_HOST}/ai_get_result_plag_check_ko1`,

  UPLOAD_FILE_AND_GET_TEXT: `${WRITING_TOOLS_API_HOST}/upload_file_and_get_text_ko1`,
};
